import { render, staticRenderFns } from "./MoedaManage.vue?vue&type=template&id=06443c18&scoped=true"
import script from "./MoedaManage.vue?vue&type=script&lang=js"
export * from "./MoedaManage.vue?vue&type=script&lang=js"
import style0 from "./MoedaManage.vue?vue&type=style&index=0&id=06443c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06443c18",
  null
  
)

export default component.exports